import { createDocFileThunk } from '../../redux/thunks/file';
import { createDocumentSchema } from '../../schema/files_schema';
import CustomInput from '../reusable/input';
import { gray } from '../../theme/themePrimitives';
import LabelWrapper from '../wrapper/label';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { CreateWordDocParams, FileObject } from '../../params/redux/file';
import { Form, Formik, FormikHelpers } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import 'react-quill/dist/quill.snow.css';

interface StartANewDocProps {
    setStartingADoc: (value: boolean) => void;
	file?: FileObject;
	editFileDoc?: string;
}

interface FormValues {
    title: string;
    content: string;
}

const StartANewDocComponent = ({ setStartingADoc, file, editFileDoc }: StartANewDocProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { selectedFolder } = useSelector((state: RootState) => state.folder);
    const { loaders } = useSelector((state: RootState) => state.file);

    const handleSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
        const data: CreateWordDocParams = {
            html: values.content,
            file_name: values.title,
            folder_id: selectedFolder?.id || 0,
            client_id: id ? parseInt(id as string, 10) : 0
        };
        try {
            await dispatch(createDocFileThunk(data)).unwrap();
            setSubmitting(false);
            setStartingADoc(false);
        } catch (e) {
            // Catch errors
        }
    };

    return (
        <Formik
            initialValues={{
                title: '',
                content: ''
            }}
            validationSchema={createDocumentSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, touched, errors, setFieldValue, isSubmitting }) => (
                <Form>
                    <Box borderTop={`1px solid ${gray[200]}`} py={2}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                            <Button variant="text" color="secondary" onClick={isSubmitting || loaders.isCreating ? () => null : () => setStartingADoc(false)}>&larr; Back</Button>
                            <Typography variant="h5" color="textSecondary">{file ? 'Edit document' : 'Create document'}</Typography>
                            <Box></Box>
                        </Box>
                        <Box display="flex" flexDirection="column" justifyContent="center">
                            <CustomInput
                                value={file?.file_name || values.title}
                                onChange={handleChange('title')}
                                onBlur={handleBlur('title')}
                                error={touched.title && errors.title}
                                fullWidth
                                label="Title"
                                placeholder="Enter title"
                                variant="outlined"
                                disabled={loaders.isCreating}
                            />
                            <Box className="text-editor" width="100%" height="30vh" mt={2}>
                                <LabelWrapper label="Content" />
                                <CustomInput
                                                                type="quill"
                                                                value={editFileDoc || values.content}
                                                                name="content"
                                                                placeholder="Type content here..."
                                                                quillHeight="22vh"
                                                                error={errors.content && touched.content}
                                                                disabled={loaders.isCreating || loaders.isUpdating}
                                                                onChangeForPhone={(value: string) => setFieldValue('content', value)}
                                                            />
                                {/* <CustomToolbar />
                                <ReactQuill
                                    onChange={(content) => }
                                    value={}
                                    placeholder="Type content here..."
                                    modules={quillModule}
                                    formats={quillFormats}
                                    theme="snow"
                                    style={{
                                        height: '22vh',
                                        borderBottomLeftRadius: '10px',
                                        borderBottomRightRadius: '10px',
                                        border:  ? `1px solid ${red[300]}` : 'none'
                                    }}
                                /> */}
                            </Box>
                            <Box display="flex" justifyContent="end" gap="10px" mt={2}>
                                <Button variant="outlined" color="secondary" onClick={() => setStartingADoc(false)} disabled={isSubmitting || loaders.isCreating}>Cancel</Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={isSubmitting || loaders.isCreating}
                                >
                                    {isSubmitting || loaders.isCreating ? 'Saving...' : 'Save'}
                                </Button>
                            </Box>
                        </Box></Box>
                </Form>
            )}</Formik>
    );
};

export default StartANewDocComponent;